import React, { Fragment, useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { Viewer, Worker, SpecialZoomLevel } from '@react-pdf-viewer/core';
import { 
  Box, Typography, Grid, Button, IconButton, Toolbar,
  TextField, InputAdornment,
  Popper, Grow, ClickAwayListener, MenuList, MenuItem, Paper,
} from '@mui/material';
import { useTranslation } from 'react-i18next';


export default function PopperMenu(props) {
  const { anchorRef, document, menuOpen, setMenuOpen, handleDownload, handleSendToEmail } = props;
  const [t] = useTranslation();
  // const [menuOpen, setMenuOpen] = useState(false);
  // const anchorRef = useRef<HTMLButtonElement>(null);
  // const handleDownloadToggle = () => {
  //   setMenuOpen((prevOpen) => !prevOpen);
  // };
  const prevOpen = useRef(menuOpen);
  useEffect(() => {
    if (prevOpen.current === true && menuOpen === false) {
      anchorRef.current!.focus();
    }
    prevOpen.current = menuOpen;
  }, [menuOpen]);
  // 关闭菜单事件
  const handleMenuClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }
    setMenuOpen(false);
  };
  return (
    <Popper 
      open={menuOpen}
      anchorEl={anchorRef.current}
      role={undefined}
      transition
      disablePortal
      style={{ zIndex: 99 }}
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          setle={{ 
            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' 
          }}
        >
          <Paper>
            <ClickAwayListener onClickAway={handleMenuClose}>
              <MenuList
                id='menu-grow' 
                autoFocusItem={menuOpen}
                style={{ zIndex: 99 }}
              >
                <MenuItem 
                  onClick={handleMenuClose}
                >
                  <Button
                    style={{ width: '100%', height: '100%', padding: 0 }}
                    onClick={(e) => {
                      if (handleDownload) {
                        handleDownload(document.id);
                      }
                      // handleMenuClose();
                    }}
                    href={document.asset.url}
                    download={document.name}
                  >
                    {/* 下载 */}
                    {t('console.setUp.download')}
                  </Button>
                </MenuItem>
                <MenuItem 
                  onClick={handleMenuClose}
                >
                  {/* 发送到邮箱 */}
                  <Button
                    style={{ width: '100%', height: '100%', padding: 0 }}
                    onClick={() => {
                      if (handleSendToEmail) handleSendToEmail(document);
                    }}
                  >
                    {/* 下载 */}
                    {t('console.setUp.sendToEmail')}
                  </Button>
                </MenuItem>
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
}